export const environment = {
  production: false,
  api: 'https://dev.ipay.01.ionia.app/api/v1',
  recapture_key: '6LfJ5hAoAAAAAMw8qBQqg3kupVDwy5ecMXFZjfXP',
  delphiusCredentials: 'delphius-credentials',
  clientId: '22E98C81-0667-40F2-94B2-0A12BA487429',
  baseAPI: 'https://dev.ipay.01.ionia.app',
};
